import { render, staticRenderFns } from "./PersonMoneyCenter.vue?vue&type=template&id=cacac7b0&scoped=true&"
import script from "./PersonMoneyCenter.vue?vue&type=script&lang=js&"
export * from "./PersonMoneyCenter.vue?vue&type=script&lang=js&"
import style0 from "./PersonMoneyCenter.vue?vue&type=style&index=0&id=cacac7b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cacac7b0",
  null
  
)

export default component.exports